import { getOoklaMeasurementType } from '@utils/ookla/getOoklaMeasurementType';

import { IOoklaData } from '@interfaces/platform/ookla';

import { DEFAULT_COLOR, EOoklaServiceLevel, OoklaLegendRange } from '@constants/ookla';

export const getOoklaServiceColor = (ookla: IOoklaData) => {
	// TODO: Update legend colors when requirements are fully defined
	const measurement = getOoklaMeasurementType(ookla.measurement);
	const colors = measurement && OoklaLegendRange[measurement];
	const value = parseFloat(ookla.value);

	if (!colors) {
		return {
			color: DEFAULT_COLOR,
			level: EOoklaServiceLevel.unknown,
		};
	}

	for (const color of colors) {
		if (value >= color.min && value <= color.max) {
			return {
				color: color.color,
				level: color.level,
			};
		}
	}

	return {
		color: DEFAULT_COLOR,
		level: EOoklaServiceLevel.unknown,
	};
};
